<template>
  <div class="all-pipeline" :class="{ horizontal: horizontal }">
    <div class="all-pipeline-container">
      <div v-if="horizontal" class="lists-container">
        <slot name="lists"></slot>
      </div>
      <div v-if="horizontal" class="cards-container" :style="height">
        <slot name="cards"></slot>
      </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'container',

  props: {
    horizontal: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: 'height: calc(100vh - 400px)',
    },
  },
}
</script>

<style scoped></style>
